export enum NotificationRecipientEnum {
    INDICATED = 'INDICATED',
    WHO_INDICATES = 'WHO_INDICATES',
}